import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-up-right', 'ChevronUpRight', [["path",{"d":"M16.121 16.364V7.879H7.636","key":"svg-0"}]]);